'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var range = require('@mx/util/range');
var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      ref: "tab-container",
      staticClass: "tab"
    }, [_c('vix-scroll-view', {
      ref: "tabMenuContainer",
      staticClass: "tab-menu-container",
      attrs: {
        "mode": "smooth",
        "bounce": _vm.bounce,
        "scrollX": true
      },
      on: {
        "scrollEnd": _vm.dealScrollEnd,
        "bounceStart": _vm.dealBounceStart
      }
    }, [_c('div', {
      staticClass: "menu-container"
    }, [_c('ul', {
      ref: "tab-menu",
      staticClass: "tab-menu"
    }, _vm._l(_vm.menu, function (item, index) {
      return _c('li', {
        key: item,
        ref: "tab-item",
        refInFor: true,
        class: {
          'tab-active': _vm.value === index
        },
        on: {
          "click": function click($event) {
            _vm.onClick(index);
          }
        }
      }, [_vm._t(index), _vm._v(" "), _c('div', {
        staticClass: "tab-title",
        domProps: {
          "innerHTML": _vm._s(item)
        }
      })], 2);
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "tab-line"
    }, [_c('div', {
      staticClass: "tab-bar",
      style: _vm.barStyle
    })])])]), _vm._v(" "), _vm._t("icon"), _vm._v(" "), _vm.mode === 'slide' ? _c('div', {
      staticClass: "tab-wrap",
      style: _vm.wrapStyle,
      on: {
        "touchstart": _vm.onTouchStart,
        "touchmove": _vm.onTouchMove,
        "touchend": _vm.onTouchEnd,
        "touchcancel": _vm.onTouchEnd
      }
    }, [_vm._t("default")], 2) : _c('div', {
      ref: "wrap",
      staticClass: "tab-wrap"
    }, [_vm._t("default")], 2)], 2);
  },
  staticRenderFns: [],
  name: 'tab',
  props: {
    menu: Array,
    value: Number,
    mode: {
      type: String,
      default: 'slide'
    }
  },
  data: function data() {
    return {
      offset: 0,
      duration: 0,
      blocks: null,
      width: utils.deviceInfo.winWidth,
      activeLineWidth: 0,
      activeLineOffset: 0,
      deltaX: 0,
      startX: 0,
      startY: 0,
      menuStartX: 0,
      leftSide: false,
      direction: '',
      menuOffsetLeft: 0,
      bounce: 30,
      translucentMaskDom: {},
      hasSlotIcon: false,
      tabMenuWidth: 0,
      lineTransition: 'none',
      overScreenWidth: true
    };
  },
  computed: {
    count: function count() {
      return this.menu.length;
    },
    barStyle: function barStyle() {
      return this.lineStyle(this.activeLineWidth, this.activeLineOffset, this.lineTransition);
    },
    wrapStyle: function wrapStyle() {
      return this.style(7.5 * this.count + 'rem', this.duration, -this.offset);
    }
  },
  mounted: function mounted() {
    this.watchMenu();
    this.judgeSlotIcon();
  },
  methods: {
    lineStyle: function lineStyle(width, offset, transition) {
      return {
        width: width,
        marginLeft: "".concat(offset, "px"),
        transition: transition
      };
    },
    style: function style(width, duration, offset) {
      return {
        width: width,
        transform: "translate3d(".concat(offset, "px, 0, 0)"),
        transitionDuration: "".concat(duration, "ms")
      };
    },
    watchMenu: function watchMenu() {
      if (this.mode === 'switch') {
        this.blocks = [].slice.call(this.$refs.wrap.children);
      }

      this.watchValue();
    },
    watchValue: function watchValue() {
      var _this = this;

      this.move();

      if (this.mode === 'switch') {
        this.blocks.forEach(function (node, index) {
          node.classList[index === _this.value ? 'remove' : 'add']('hidden');
        });
      }
    },
    dealScrollEnd: function dealScrollEnd(offsetX) {
      if (offsetX > this.width - this.tabMenuWidth) {
        this.dealTranslucentMask('block');
      }
    },
    dealBounceStart: function dealBounceStart(offsetX) {
      if (offsetX < 0) {
        this.dealTranslucentMask('none');
      }
    },
    judgeOverScreenWidth: function judgeOverScreenWidth() {
      var tabMenu = this.$refs['tab-menu'];
      this.overScreenWidth = tabMenu.offsetWidth > this.width;
    },
    judgeSlotIcon: function judgeSlotIcon() {
      var allSlots = this.$slots || {};

      if (allSlots.hasOwnProperty('icon')) {
        this.hasSlotIcon = true;
        var iconDom = allSlots['icon'][0] || {};
        var iconWidth = iconDom.elm.clientWidth || 0;
        var tabContainer = this.$refs['tab-container'];
        var tabMenu = this.$refs['tab-menu'];
        var translucentMaskDom = document.createElement('span');
        translucentMaskDom.style.pointerEvents = 'none'; // tab 标题高度

        var baseTabHeight = 42;
        var translucentMaskWidth = 35;
        var remCoefficient = 50;
        var translucentMaskStyle = translucentMaskDom.style;
        translucentMaskStyle.position = 'absolute';
        translucentMaskStyle.width = "".concat(translucentMaskWidth / remCoefficient, "rem");
        translucentMaskStyle.height = "".concat(baseTabHeight / remCoefficient, "rem");
        translucentMaskStyle.top = "0";
        translucentMaskStyle.right = "".concat(iconWidth / remCoefficient, "rem");
        translucentMaskStyle.background = 'linear-gradient(270deg, #FFFFFF 13%, rgba(255,255,255,0.00) 100%)';
        this.translucentMaskDom = translucentMaskDom;
        tabContainer.appendChild(translucentMaskDom);
        tabMenu.style.paddingRight = "".concat(iconWidth / remCoefficient, "rem");
      } else {
        this.hasSlotIcon = false;
      }
    },
    onTouchStart: function onTouchStart(event) {
      this.deltaX = 0;
      this.duration = 0;
      this.leftSide = false;
      this.direction = '';
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
    },
    onTouchMove: function onTouchMove(event) {
      this.deltaX = event.touches[0].clientX - this.startX;
      this.direction = this.direction || this.getDirection(event.touches[0]);
      var factor = Math.abs(this.deltaX / this.width);
      var targetTabIndex = this.value + (this.deltaX > 0 ? -1 : 1);
      var tabTitleList = this.tabTitleList;
      if (!tabTitleList || targetTabIndex < 0 || targetTabIndex > tabTitleList.length - 1) return;
      targetTabIndex = range.range(targetTabIndex, [0, tabTitleList.length - 1]);
      this.lineTransition = 'none';
      var targetTab = tabTitleList[targetTabIndex];
      var curruntTab = tabTitleList[this.value];
      var targetTabOffsetLeft = targetTab.offsetLeft;
      var curruntTabOffsetLeft = curruntTab.offsetLeft;
      var slideX = (targetTabOffsetLeft - curruntTabOffsetLeft) * factor;
      this.activeLineOffset = curruntTabOffsetLeft + slideX;
      var targetTabWidth = targetTab.offsetWidth;
      var curruntTabWidth = curruntTab.offsetWidth;
      var deltaWidth = (targetTabWidth - curruntTabWidth) * factor + 15 * Math.sin(Math.PI * factor);
      this.activeLineWidth = "".concat(curruntTabWidth + deltaWidth, "px");

      if (this.leftSide) {
        return;
      }

      if (this.value === 0 && this.deltaX > 0) {
        this.leftSide = true;
        return;
      }

      if (this.direction !== 'horizontal') {
        return;
      } else {
        event.preventDefault();
      }

      if ((this.value || this.deltaX <= 0) && (this.value !== this.count - 1 || this.deltaX >= 0)) {
        this.move(this.deltaX);
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (this.leftSide || this.direction === 'vertical') {
        return;
      }

      var step = this.deltaX > 50 && this.value !== 0 ? -1 : this.deltaX < -50 && this.value !== this.count - 1 ? 1 : 0;
      this.duration = 400;

      if (step === 0) {
        this.setActiveLine(this.value);
      }

      this.switchTo(this.value + step);
    },
    move: function move() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.offset = range.range(this.width * this.value - offset, [0, this.width * (this.count - 1)]);
    },
    setActiveLine: function setActiveLine(index, isInit) {
      var tabTitleList = this.$refs['tab-item'];
      var tabMenuWidth = this.$refs['tab-menu'].offsetWidth;
      var activeTabTitle = tabTitleList[index];
      var activeOffsetLeft = activeTabTitle.offsetLeft;
      var halfWindowWidth = this.width / 2;
      this.activeLineWidth = "".concat(activeTabTitle.offsetWidth, "px");
      this.tabMenuWidth = tabMenuWidth;
      this.tabTitleList = tabTitleList;
      this.lineTransition = isInit ? 'none' : '0.3s ease-in-out';

      if (this.overScreenWidth) {
        if (activeOffsetLeft > halfWindowWidth && Math.abs(this.menuOffsetLeft) < Math.abs(tabMenuWidth - this.width)) {
          this.menuOffsetLeft = halfWindowWidth - activeOffsetLeft;
          this.dealTranslucentMask('block');
        }

        if (Math.abs(this.menuOffsetLeft) > tabMenuWidth - this.width) {
          this.menuOffsetLeft = -Math.abs(tabMenuWidth - this.width);
          this.dealTranslucentMask('none');
        }

        if (activeOffsetLeft + this.menuOffsetLeft < halfWindowWidth && this.menuOffsetLeft < 0) {
          this.menuOffsetLeft = halfWindowWidth - activeOffsetLeft;
          this.dealTranslucentMask('block');
        }

        if (this.menuOffsetLeft > 0) {
          this.menuOffsetLeft = 0;
          this.dealTranslucentMask('block');
        }
      }

      this.activeLineOffset = activeOffsetLeft;
      this.$refs.tabMenuContainer.$emit('scrollX', this.menuOffsetLeft, this.duration);
    },
    dealTranslucentMask: function dealTranslucentMask(displayProp) {
      if (this.hasSlotIcon) {
        this.translucentMaskDom.style.display = displayProp;
      }
    },
    switchTo: function switchTo(index) {
      this.curruntTitle = index;

      if (index === this.value) {
        return this.move();
      }

      this.$emit('input', index);
      this.setActiveLine(index);
    },
    onClick: function onClick(index) {
      this.duration = 300;
      this.switchTo(index);
    },
    getDirection: function getDirection(touch) {
      var distanceX = Math.abs(this.deltaX);
      var distanceY = Math.abs(touch.clientY - this.startY);
      return distanceX > distanceY ? 'horizontal' : distanceX < distanceY ? 'vertical' : '';
    }
  },
  watch: {
    menu: function menu() {
      var _this2 = this;

      this.watchMenu();
      this.$nextTick(function () {
        var isInit = true;

        _this2.setActiveLine(_this2.value, isInit);

        _this2.judgeOverScreenWidth();
      });
    },
    value: function value() {
      this.watchValue();
    }
  }
});

exports.default = index;
